module.exports = __webpack_public_path__ + "img/ia.2056678a.png";